"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
const utils_1 = require("@osmosys/utils");
exports.fetchWithProgress = (input, init) => {
    return new Promise((resolve, reject) => {
        const url = typeof input === 'string' ? input : input.url;
        const method = typeof input === 'string' ? init.method : input.method;
        const body = typeof input === 'string' ? init.body : input.body;
        const headers = typeof input === 'string' ? init.headers : input.headers;
        const onUploadProgress = typeof input === 'string'
            ? init.onUploadProgress
            : input.onUploadProgress || init.onUploadProgress;
        const xhr = new XMLHttpRequest();
        xhr.open(method, url);
        Object.keys(headers).forEach(headerKey => {
            xhr.setRequestHeader(headerKey, headers[headerKey]);
        });
        xhr.onload = () => {
            resolve({
                json: () => Promise.resolve(JSON.parse(xhr.responseText)),
                ok: true,
                text: () => Promise.resolve(xhr.responseText),
            });
        };
        xhr.onerror = reject;
        if (xhr.upload) {
            xhr.upload.onprogress = event => {
                const progress = (event.loaded / event.total) * 100;
                utils_1.logger.debug(`fetchWithProgress | Request ${url} | ${progress}% uploaded`);
                if (onUploadProgress) {
                    onUploadProgress(progress);
                }
            };
        }
        xhr.send(body);
    });
};
//# sourceMappingURL=fetchWithProgress.js.map